import { gql } from "@apollo/client";

export const UPDATE_ORDER_NOTE = gql`
    mutation UpdateOrderNote($input: UpdateOrderNoteInput!) {
        updateOrderNote(input: $input)
    }
`;

export interface UpdateOrderNoteInputType {
    orderId: string;
    trackingNumber?: string | null;
    note: string;
    warehouseId?: string | null;
    noteType: string;
}

export interface UpdateOrderNoteVariables {
    input: UpdateOrderNoteInputType;
}

export interface UpdateOrderNoteResponse {
    updateOrderNote: boolean;
}

